import type { IReducer, IReducers, Saga0 } from './interface';
import { IWrapperReducer } from './reducerCreator';
import { runSaga } from './sagaMiddleWare';

interface IReducerOptions {
    reducer: IReducer;
    parentReducerName: string;
}

class DataFlow {
    public static init(flow: { reducer: IReducer; saga: Saga0 }, parentReducerName: string) {
        const { reducer, saga } = flow;
        DataFlow.bindReducer({ reducer, parentReducerName });
        runSaga(saga);
    }
    public static addReducers(key: string, reducer: IReducer) {
        DataFlow.reducers[key] = reducer;
    }

    private static reducers: IReducers = {};

    private static bindReducer(reducerOption: IReducerOptions) {
        const { reducer, parentReducerName } = reducerOption;
        const reducerWrapper = DataFlow.reducers[parentReducerName] as IWrapperReducer;
        if (!reducerWrapper) {
            throw new Error('请按照规范定义容器 reducer !!!');
        }
        if (!reducerWrapper.register) {
            throw new Error('请用reducerCreator 生成容器 reducer !!!');
        }
        reducerWrapper.register(reducer);
    }
}

export default DataFlow;
